define('modules/cms/controllers/TemplatePageFormController',[
	'modules/module',
	'settings',
	'services/TemplatePageService',
	'services/NavigationService',
	'services/CmsTagUnpagedService',
	'services/ContentBuilderHelper',
	'services/CmsTagService',
	'directives/formatDate/formatDate',
	'directives/contentConfigurator/_contentConfigurator/ContentConfigurator',
	'directives/controls/customInputTime/CustomInputTime',
	'directives/tinyMce/tinyMce',
], function (module) {
	'use strict';
	module.controller('TemplatePageFormController', [
		'$scope',
		'$q',
		'$controller',
		'$timeout',
		'PublishStateService',
		'CmsTagUnpagedService',
		'CmsTagService',
		'ContentBuilderHelper',
		'BASE_TEMPLATES_PATH',
		TemplatePageFormController,
	]);
});

function TemplatePageFormController(
	$scope,
	$q,
	$controller,
	$timeout,
	PublishStateService,
	CmsTagUnpagedService,
	CmsTagService,
	ContentBuilderHelper,
	BASE_TEMPLATES_PATH
) {
	angular.extend(
		this,
		$controller('CmsFormBaseController', {
			$scope: $scope,
		})
	);

	$scope.prepareSaveDelayed = function () {
		return $q(function (resolve, reject) {
			ContentBuilderHelper.toggleEditGlobal(false, true);
			$timeout(function () {
				ContentBuilderHelper.saveGlobal();
				if (typeof $scope.entity.layout.json === 'object') {
					$scope.entity.layout.json = angular.toJson($scope.entity.layout.json);
				}
				resolve();
			}, 1000);
		});
	};

	$scope.prepareCreateDelayed = $scope.prepareSaveDelayed;

	$scope.tag = {};

	$scope.formTabs = [
		{
			label: 'FIELDS.CONTENT',
			template: BASE_TEMPLATES_PATH + '/cms/partials/_form-template-pages-content.html',
			active: true,
		},
	];

	$scope.validationConfig = {
		name: {
			method: 'isset',
			fieldName: 'Name',
		},
	};

	$scope.tinymceOptions = {
		theme: 'modern',
		height: '500',
		convert_urls: false,
		relative_urls: false,
		remove_script_host: false,
		plugins: [
			'link advlist lists image charmap print preview hr anchor pagebreak',
			'searchreplace wordcount visualblocks visualchars code fullscreen',
			'insertdatetime media nonbreaking save table contextmenu directionality',
			'emoticons template paste textcolor colorpicker textpattern imagetools',
			'fullpage moodiaimage shortcodes',
		],
		menubar: 'insert | tools',
		toolbar1:
			'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link moodiaimage',
		toolbar2:
			'print preview media | forecolor backcolor emoticons | fontsizeselect | fontselect | code | shortcodes',
		image_advtab: true,
	};

	$scope.publishStates = [];
	$scope.tags = [];
	$scope.selectedItems = {};
	$scope.listState = 'root.templatePages';
	$scope.entityType = 'TemplatePage';

	$scope.init('TemplatePage').then(function () {
		$timeout(function () {
			if ($scope.newEntity) {
				$scope.entity.layout = {};
			}
		}, 1000);
	});
}
;
